import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsActigraphComponent } from './simple-icons-actigraph.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsActigraphComponent ],
    exports:      [ SimpleIconsActigraphComponent ],
    bootstrap:    []
})
export class SimpleIconsActigraphModule {}
